import { render, staticRenderFns } from "./HeraDesktopFooter.vue?vue&type=template&id=57f92656&scoped=true&"
import script from "./HeraDesktopFooter.vue?vue&type=script&lang=js&"
export * from "./HeraDesktopFooter.vue?vue&type=script&lang=js&"
import style0 from "./HeraDesktopFooter.vue?vue&type=style&index=0&id=57f92656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f92656",
  null
  
)

export default component.exports